/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Seller_Dashboard_Upgrade_SubtitleInputs */

const en_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upgrade to Sovereign for ${i?.fee}% fees & unlimited listings`)
};

const es_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualiza a Sovereign para comisiones del ${i?.fee}% y anuncios ilimitados`)
};

const fr_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passez à Sovereign pour des frais à ${i?.fee} % et des annonces illimitées`)
};

const de_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upgrade auf Sovereign für ${i?.fee}% Gebühren & unbegrenzte Inserate`)
};

const ja_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`手数料${i?.fee}%と出品数無制限を利用するにはSovereignにアップグレードしてください`)
};

const zh_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`升级到 Sovereign 以享受 ${i?.fee}% 手续费并无限制发布商品`)
};

const ar_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`قم بالترقية إلى Sovereign للحصول على رسوم ${i?.fee}% وإعلانات غير محدودة`)
};

const id_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tingkatkan ke Sovereign untuk biaya ${i?.fee}% & listing tak terbatas`)
};

const it_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passa a Sovereign per commissioni al ${i?.fee}% e annunci illimitati`)
};

const ru_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Перейдите на Sovereign для комиссии ${i?.fee}% и неограниченного числа объявлений`)
};

const pt_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faça upgrade para o Sovereign para taxas de ${i?.fee}% e anúncios ilimitados`)
};

const ko_seller_dashboard_upgrade_subtitle = /** @type {(inputs: Seller_Dashboard_Upgrade_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% 수수료 및 무제한 상품 등록을 위해 Sovereign으로 업그레이드하세요`)
};

/**
* | output |
* | --- |
* | "Upgrade to Sovereign for {fee}% fees & unlimited listings" |
*
* @param {Seller_Dashboard_Upgrade_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_upgrade_subtitle = /** @type {((inputs: Seller_Dashboard_Upgrade_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Upgrade_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "es") return es_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "fr") return fr_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "de") return de_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "ja") return ja_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "zh") return zh_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "ar") return ar_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "id") return id_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "it") return it_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "ru") return ru_seller_dashboard_upgrade_subtitle(inputs)
	if (locale === "pt") return pt_seller_dashboard_upgrade_subtitle(inputs)
	return ko_seller_dashboard_upgrade_subtitle(inputs)
});